/**
 * Bridge for plugin panels (which can't import the host map store) to fly the
 * map. Listens for the typed MAP_FLYTO_EVENT window event and forwards it to the
 * map store's fly-to.
 */

import { useEffect } from 'react';
import { MAP_FLYTO_EVENT, type MapFlyToDetail } from '@vtak/shared';
import { useMapStore } from '@/stores/map-store';

/** Subscribe to external fly-to requests for the lifetime of the map. */
export function useExternalFlyTo(): void {
  useEffect(() => {
    const handle = (event: Event): void => {
      const detail = (event as CustomEvent<MapFlyToDetail>).detail;
      if (!detail) return;
      useMapStore.getState().setFlyTo({ lat: detail.lat, lng: detail.lon, zoom: detail.zoom });
    };
    window.addEventListener(MAP_FLYTO_EVENT, handle);
    return () => window.removeEventListener(MAP_FLYTO_EVENT, handle);
  }, []);
}
